<div class="modal-header">
    <div class="d-flex justify-content-center">
      <h4><strong>{{title}}</strong></h4>
    </div>
  </div>
  <div class="modal-body">
    <div class="d-flex my-3">
      <p [innerHtml]="message"></p>
    </div>
  </div>
  <div class="modal-footer">
  <button
    class="btn btn-primary"
    (click)="activeModal.close(true)">
    Aceptar
  </button>
  </div>
